import EntitiesView from 'Components/EntitiesView';
import { actions } from 'ducks/equipmentCategories';
import Show from 'Pages/EquipmentCategories/Show';
import React from 'react';
import { useSelector } from 'react-redux';
import columns from 'utils/columns/equipmentCategories';

const EquipmentCategoriesPage = props => {
    const currentUser = useSelector(state => state.auth.currentUser);
    const equipmentCategories = useSelector(state => state.equipmentCategories);
    const stateProps = { ...equipmentCategories, currentUser };

    const { useChangeSearch, useChangeSort, useFetchAll, useToggleAll, useToggleOne } = actions;
    const toggleOne = useToggleOne();
    const actionProps = ({
        changeSearch: useChangeSearch(),
        changeSort: useChangeSort(),
        fetchData: useFetchAll(),
        toggleAll: useToggleAll(),
        toggleOne: event => {
            event.stopPropagation();
            return toggleOne(event.target.name);
        }
    });

    return (
        <EntitiesView
            columns={columns}
            showComponent={Show}
            {...stateProps}
            {...actionProps}
            {...props}
        />
    );
};

export default EquipmentCategoriesPage;
